import { Injectable } from '@angular/core';
import { AccountInformation } from 'src/app/parameters/accounts/shared/models/account-information.model';

import { SiteTypeEnum } from '../../enums';
import { QuickRepliesElementsConfiguration } from '../../models';
import { StrategyAbstractService } from '../strategy-abstract.service';

@Injectable({
  providedIn: 'root',
})
export class FacebookService extends StrategyAbstractService {
  constructor() {
    super();
  }

  getType(): number {
    return 1; // alcmeon.db.Sites.TYPE_FACEBOOK
  }
  getTypeString(): string {
    return SiteTypeEnum.Facebook;
  }
  getAllTasksTypes(): number[] {
    return [6, 7, 8, 20, 33];
  }

  getPrivateTaskTypes(): number[] {
    return [6];
  }

  getPublicTaskTypes(): number[] {
    return [7, 8, 20, 33];
  }

  canHaveSurveys(): boolean {
    return true;
  }

  /*
   * We removed FB event comments from the inbox list as the API doesn't allow us to retrieve them anymore,
   * but the history must remain acccessible in the search and metric pages
   */
  getAllTasksTypesForSearchAndMetrics(): number[] {
    return [6, 7, 8, 23, 20, 33];
  }

  getTaskTypesGroups() {
    return [
      {
        translateKey: 'facebook/messenger',
        taskTypes: [6],
      },
      {
        translateKey: 'facebook/public',
        taskTypes: [7, 8, 20, 33],
      },
    ];
  }

  getTaskTypeString(taskType: number): string {
    const mapping = {
      6: 'facebook/private',
      7: 'facebook/user_posts',
      8: 'facebook/news_comments',
      23: 'facebook/event_comments',
      20: 'facebook/ad_comments',
      33: 'facebook/ratings',
    };
    return mapping[taskType];
  }

  getTaskTypeQueueId(taskType: number): string {
    const mapping = {
      6: 'fb-private',
      7: 'fb-user-posts',
      8: 'fb-news-comments',
      23: 'fb-event-comments',
      20: 'fb-ad-comments',
      33: 'fb-rating-comments',
    };
    return mapping[taskType];
  }

  taskTypeHasPublicationFilter(taskType: number): boolean {
    return taskType === 8 || taskType === 20;
  }

  taskTypeCanHaveMentionBtn(taskType: number): boolean {
    return [7, 8, 20, 33].includes(taskType);
  }

  areAttachmentsAllowedWhenReplyingToPublicAsPrivate(): boolean {
    return false;
  }

  // TODO type
  getQuickRepliesElementsConfig(): QuickRepliesElementsConfiguration {
    const isPrivate = true;
    const configuration: QuickRepliesElementsConfiguration = {
      maxAnswerNb: 11,
      answerLabelMaxLength: 20,
      hasDescription: false,
      canHaveUserVariableInRootQuestion: true,
      hasPhoneEmailAnswerType: true,
      hasUrlAnswerType: false,
      hasTargetAppId: true,
      boxesCanBeTested: true,
      hasPersistentMenu: true,
      hasWelcomeMessage: true,
      imageMimeTypes: 'image/*',
      editorConfiguration: {
        fileEnabled: true,
        hasImageControl: false,
      },
      sendTextAfterButtonChoice: false,
      canSendVideo: true,
    };
    if (isPrivate) {
      configuration.editorConfiguration = {
        ...configuration.editorConfiguration,
        maxCharsNumber: 2000,
      };
    }
    return configuration;
  }

  externalInboxURL(site: AccountInformation): string {
    if (site.authorized_user && site.authorized_user.external_id) {
      return `https://messenger.com/t/${site.authorized_user.external_id}`;
    }
    return null;
  }

  handlesPublish(): boolean {
    return true;
  }

  getSatisfactionSurveysExpirationHoursOptions(): number[] {
    return [0, 12, 23, 24, 36, 48, 60, 72, 84, 96, 240, 360];
  }

  // Currently 21 days max time span to reply to a user msg on fb messenger - could change
  getMaxAllowedDaysToReplyToPrivateMsg(): number {
    return 7;
  }
}
